import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Problem`}</h2>
    <p>{`This service has already been packaged into a container image, but there is one special requirement:`}</p>
    <ul>
      <li parentName="ul">{`The legacy app is hard-coded to only serve content on port `}<inlineCode parentName="li">{`8989`}</inlineCode>{`, but the team wants to be able to access the service using the standard port `}<inlineCode parentName="li">{`80`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Your task is to build a Kubernetes pod that runs this legacy container and uses the ambassador design pattern to expose access to the service on port `}<inlineCode parentName="p">{`80`}</inlineCode>{`.`}</p>
    <p>{`This setup will need to meet the following specifications:`}</p>
    <ul>
      <li parentName="ul">{`The pod should have the name `}<inlineCode parentName="li">{`vader-service`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`vader-service`}</inlineCode>{` pod should have a container that runs the legacy vader service image: `}<inlineCode parentName="li">{`ibmcase/millennium-falcon:1`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`vader-service`}</inlineCode>{` pod should have an ambassador container that runs the `}<inlineCode parentName="li">{`haproxy:1.7`}</inlineCode>{` image and proxies incoming traffic on port `}<inlineCode parentName="li">{`80`}</inlineCode>{` to the legacy service on port `}<inlineCode parentName="li">{`8989`}</inlineCode>{` (the HAProxy configuration for this is provided below).`}</li>
      <li parentName="ul">{`Port `}<inlineCode parentName="li">{`80`}</inlineCode>{` should be exposed as a `}<inlineCode parentName="li">{`containerPort`}</inlineCode>{`.`}</li>
    </ul>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note`}</strong>{`: You do not need to expose port 8989`}</p>
    </InlineNotification>
    <ul>
      <li parentName="ul">{`The HAProxy configuration should be stored in a ConfigMap called `}<inlineCode parentName="li">{`vader-service-ambassador-config`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`The HAProxy config should be provided to the ambassador container using a volume mount that places the data from the ConfigMap in a file at /usr/local/etc/haproxy/haproxy.cfg.
haproxy.cfg should contain the following configuration data:`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`global
    daemon
    maxconn 256

defaults
    mode http
    timeout connect 5000ms
    timeout client 50000ms
    timeout server 50000ms

listen http-in
    bind *:80
    server server1 127.0.0.1:8989 maxconn 32
`}</code></pre>
    <p>{`Once your pod is up and running, it’s a good idea to test it to make sure you can access the service from within the cluster using port 80. In order to do this, you can create a busybox pod in the cluster, and then run a command to attempt to access the service from within the busybox pod.`}</p>
    <p>{`Create a descriptor for the busybox pod called `}<inlineCode parentName="p">{`busybox.yml`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`apiVersion: v1
kind: Pod
metadata:
  name: busybox
spec:
  containers:
  - name: myapp-container
    image: radial/busyboxplus:curl
    command: ['sh', '-c', 'while true; do sleep 3600; done']
`}</code></pre>
    <p>{`Create the busybox testing pod.`}</p>
    <pre><code parentName="pre" {...{}}>{`kubectl apply -f busybox.yml
`}</code></pre>
    <p>{`Use this command to access `}<inlineCode parentName="p">{`vader-service`}</inlineCode>{` using port 80 from within the busybox pod.`}</p>
    <pre><code parentName="pre" {...{}}>{`kubectl exec busybox -- curl $(kubectl get pod vader-service -o=custom-columns=IP:.status.podIP --no-headers):80
`}</code></pre>
    <p>{`If the service is working, you should get a message that the hyper drive of the millennium falcon needs repair.`}</p>
    <p><em parentName="p">{`Relevant Documentation:`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/concepts/cluster-administration/logging/#using-a-sidecar-container-with-the-logging-agent"
        }}>{`Kubernetes Sidecar Logging Agent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/tasks/access-application-cluster/communicate-containers-same-pod-shared-volume/"
        }}>{`Shared Volumes`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/blog/2015/06/the-distributed-system-toolkit-patterns/"
        }}>{`Distributed System Toolkit Patterns`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      